// import '../../../../wwwroot/styles/animations.css'
declare const AssetRoot: string;
import * as React from 'react';
import * as Request from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import { connect } from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import  { PapaJohnsFooter}  from './PapaJohnsFooter'; 
import PapaJohnsDropdownMenu from './PapaJohnsDropdownMenu';
import { browserHistory } from 'react-router';
import { FaBars } from 'react-icons/fa'; 
import { withRouter, RouteComponentProps } from 'react-router';

import  PapaJohnsBannerImage  from './PapaJohnsBannerImage';
import ProgressBar from '../Components/ProgressBar';
import BackButton from '../Components/BackButton';


const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 20px 10vh 20px',
    background: '#f2f2f2',
    fontFamily: "'Montserrat', sans-serif",
  },
  header: {
    padding: '20px',
    backgroundColor: 'rgb(242, 242, 242)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  progressBarContainer: {
    flex: 1, // This will allow the progress bar to expand
  },
  menuIcon: {
    cursor: 'pointer',
    position: 'relative', // The menu will be positioned relative to this
  },
  menu: {
    cursor: 'pointer',
    position: 'absolute',
    top: '100%', // Position the menu below the icon
    right: 0,
    backgroundColor: 'white',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    padding: '15px',
    zIndex: 1000,
    minWidth: '200px',
    marginTop: '10px', // Give some space between the icon and the menu
    overflow: 'hidden',
    opacity: 0.95,
    transition: 'opacity 250ms ease-in-out',
  },
  menuItem: {
    padding: '12px 15px',
    borderBottom: '1px solid #eaeaea',
    transition: 'background-color 250ms ease-in-out',
    ':last-child': {
      border: 'none',
    },
    ':hover': {
      backgroundColor: '#f8f9fa', // Light grey background on hover
    },
  },
  menuLink: {
    textDecoration: 'none',
    color: '#333',
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'block',
    transition: 'color 250ms ease-in-out',
    ':hover': {
      color: '#008e6a', // Highlight text on hover
    },
  },
  colorSelectContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: '20px',
  },
  colorButton: {
    padding: '10px 20px',
    margin: '5px',
    backgroundColor: '#008e6a',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
    ':hover': {
      transform: 'scale(1.05)',
    },
  },
  menuContainer: {
    display: 'inline-block',
    width: '50px', // Set this to the width of your menu icon
    position: 'relative',
  },
  
  productDetails: {
    marginTop: '20px',
    backgroundColor: '#fff',
    borderRadius: '15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center',
  },
  productImage: {
    maxWidth: '100%',
    borderRadius: '10px',
  },
  selectProductButton: {
    marginTop: '10px',
    padding: '10px 20px',
    backgroundColor: '#D22328',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    ':hover': {
      backgroundColor: '#A81B22',
    },
  },
};
interface PapaJohnsColorSelectProps {
  LoginData: Tgcc.LoginData;
  UserInfo: Tgcc.UserInfo;
  ActiveProof: Tgcc.Proof; 
  dispatch?: any;
}

// If you have specific route parameters
interface RouteParams {
  id?: string; // Example route param
}

// Extend the component props with RouteComponentProps for routing props
interface PapaJohnsColorSelectCombinedProps extends PapaJohnsColorSelectProps, RouteComponentProps<RouteParams, any> {}

const mapStateToProps = (state: Tgcc.GlobalState): PapaJohnsColorSelectProps => ({
  LoginData: state.LoginData,
  UserInfo: state.UserInfo,
  ActiveProof: state.ActiveProof,
});

class _PapaJohnsColorSelect extends React.Component<PapaJohnsColorSelectCombinedProps, any> {
  state = {
    selectedColor: { name: 'Heathered Kelly Green', colorCode: '#4F946A' },
    productDetails: undefined,
    activeProof: undefined,
    isMenuOpen: false,
};

  colorMapping = {
    'heatheredkellygreen': '#4F946A',
    'evergreen': '#30534D',
    'heatheredred': '#B23947',
  };


  componentDidMount() {
    // Checks if the URL has a query parameter indicating a new order should be started
    const queryParams = new URLSearchParams(this.props.location.search);
    const startingNewOrder = queryParams.get('newOrder') === 'true';
  
    this.handleColorSelect({
      name: 'Heathered Kelly Green',
      colorCode: this.colorMapping['heatheredkellygreen']
    });
    
    if (startingNewOrder) {
      // If starting a new order, clear the previous active proof from Redux and localStorage
      this.startNewOrder();
    } else {
      // If continuing with an existing order, load the active proof from localStorage
      this.loadStateFromLocalStorage();
      // Ensure the active proof is initialized (e.g., loading details from a server or setting defaults)
      this.ensureActiveProofInitialized();
    }
    // Any other initialization logic can go here
  }

  componentDidUpdate(prevProps) {
    const prevQuery = new URLSearchParams(prevProps.location.search);
    const currentQuery = new URLSearchParams(this.props.location.search);
  
    // Check if the 'newOrder' query parameter has changed to 'true'
    if (currentQuery.get('newOrder') === 'true' && prevQuery.get('newOrder') !== 'true') {
      this.startNewOrder();
    }
  }
  

  startNewOrder = () => {
    // Clear the active proof from local storage and Redux state
    localStorage.removeItem('activeProof');
    this.props.dispatch({
      type: Tgcc.StateAction.ResetActiveProof,
    });
  
    // Reset component state to defaults for new order
    this.setState({
      selectedColor: { name: 'Heathered Kelly Green', colorCode: '#4F946A' },
      productDetails: undefined,
      activeProof: undefined,
      isMenuOpen: false,
    }, () => {
      this.ensureActiveProofInitialized(); // Make sure a new proof is initialized
    });
  };

  loadStateFromLocalStorage = () => {
    const savedState = localStorage.getItem('activeProof');
    if (savedState) {
      const activeProof = JSON.parse(savedState);
      // Dispatch to Redux store
      this.props.dispatch({
        type: Tgcc.StateAction.SetActiveProof,
        payload: activeProof,
      });
      // Update component's state
      this.setState({ activeProof });
    }
  }
  
  saveStateToLocalStorage = (activeProof: Tgcc.Proof) => {
    localStorage.setItem('activeProof', JSON.stringify(activeProof));
}

  toggleMenu = () => {
    this.setState((prevState) => ({ isMenuOpen: !prevState.isMenuOpen }));
  };

  ensureActiveProofInitialized = () => {
    if (!this.props.ActiveProof || !this.props.ActiveProof.proofId) {
      Request.initProof()
      .then(proofId => {
        const newProof = new Tgcc.Proof();
        newProof.proofId   = proofId;
        newProof.phone     = this.props.UserInfo.phone;
        newProof.smsAllowed= this.props.UserInfo.smsAllowed;
    
        this.props.dispatch({
          type: Tgcc.StateAction.SetActiveProof,
          payload: newProof
        });
        this.setState({ activeProof: newProof });
      })
      .catch(err => {
        console.error("Failed to initialize proof:", err);
      });
    
    } else {
      // If there's already an ActiveProof, use it to set the local component state
      this.setState({ activeProof: this.props.ActiveProof });
    }
  };


  handleColorSelect = (colorOption) => {
    // Fetch product details
    this.fetchProductDetailsForColor(colorOption.name, (productDetails) => {
      const newActiveProof = {
        ...this.props.ActiveProof,
        product: {
          ...productDetails,
          colorName: colorOption.name,
          colorCode: colorOption.colorCode,
        },
      };
      // Update component's state
      this.setState({ activeProof: newActiveProof, selectedColor: colorOption, productDetails });
      // Dispatch to Redux store
      this.props.dispatch({
        type: Tgcc.StateAction.SetActiveProof,
        payload: newActiveProof,
      });
      // Save to localStorage
      this.saveStateToLocalStorage(newActiveProof);
    });
  };
  
  

  fetchProductDetailsForColor = (colorName, callback?) => {
    const division = 'Corporate';
    const style = 'DT6000';

    // Fetch all product details using findProducts
    Request.findProducts(
        new Date().getTime(), division, [], ['District'], '', style, colorName,
        [], [], [], [], [], [], [], false, false, '',
        (requestTime, products) => {
            if (products.length > 0) {
                // Use the first product as a base for the details
                const baseProductDetails = { ...products[0] };

                // Fetch sizes using the new sizes request
                Request.getSizesForStyleAndColor(style, colorName, (sizes) => {
                    // Combine product details with sizes
                    const aggregatedProductDetails = {
                        ...baseProductDetails,
                        sizes: sizes.map(sizeObj => sizeObj.size), // Extract size strings
                    };

                    // Update state with the aggregated product details
                    this.setState({ productDetails: aggregatedProductDetails }, () => {
                        if (callback) {
                            callback(aggregatedProductDetails);
                        }
                    });
                });
            }
        }
    );
};


  updateActiveProof = (colorOption, productDetails) => {
    const sizes = productDetails.sizes;

    // Directly use productDetails argument provided to the function
    // No need to destructure it from this.state
    const newActiveProof = {
      ...this.state.activeProof,
      product: {
        ...this.state.activeProof.product, // Preserve existing product details
        brand: "District",
        style: "DT6000",
        colorName: colorOption.name,
        colorCode: colorOption.colorCode,
        description: "Very Important Tee",
        image: productDetails.image,
        thumbnail: productDetails.thumbnail,
        sizes: sizes,
      }
    };
  
    this.setState({ activeProof: newActiveProof }, () => {
      console.log("New active proof set: ", this.state.activeProof); // Log new state
    });

    this.saveStateToLocalStorage(newActiveProof);

  };
  
  
handleProductSelect = (selectedProduct) => {
  // Ensure you're spreading the existing props.activeProof
  const newActiveProof = { 
    ...this.props.ActiveProof,
    product: selectedProduct
  };

  // Dispatch the updated active proof to the Redux store
  this.props.dispatch({
    type: Tgcc.StateAction.SetActiveProof,
    payload: newActiveProof // The updated active proof with the product
  });

  // Save the updated active proof to localStorage
  this.saveStateToLocalStorage(newActiveProof); // Pass the new active proof here

  // Navigate to the design selection page
  browserHistory.push('/papajohns/select-design');
}

  
  

  handleDesignSelection = (design) => {
      this.setState({ activeProof: { ...this.state.activeProof, design: design } });
  };
  
    render() {
      const { selectedColor, productDetails, isMenuOpen } = this.state;
      
      // Apply the replacement for product image paths
      const correctedImagePath = productDetails?.image.replace('images/products/', 'products/');
      
      // Define the current step and total steps for the progress bar
      const currentStep = 1; // This is the first step in the process
      const totalSteps = 3; // Assuming there are 3 steps in total
    
      let subtitle = "Choose your preferred shirt color. This color will be the base for your custom design.";
    
      return (
        <div>
          <PapaJohnsBannerImage />
          
          {/* Header with Progress Bar and Menu */}
          <div style={styles.header}>
            {/* Wrap ProgressBar in its container */}
            <div style={styles.progressBarContainer}>
              <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
            </div>
    
            {/* Menu Container */}
            <div style={styles.menuContainer}>
              {/* <FaBars style={styles.menuIcon} size={24} onClick={this.toggleMenu} /> */}
    
              {/* PapaJohnsDropdownMenu Component */}
              <PapaJohnsDropdownMenu
                isMenuOpen={this.state.isMenuOpen}
                toggleMenu={this.toggleMenu}
              />
            </div>
          </div>
      
          {/* Color Selection */}
          <div style={styles.container}>
            <div style={{ width: '100%', textAlign: 'center', marginBottom: '20px' }}>
              <h2>Select a Color</h2>
              <p>{subtitle}</p>
            </div>
    
            <div style={styles.colorSelectContainer}>
              {[
                { name: 'Heathered Kelly Green', code: 'heatheredkellygreen' },
                { name: 'Evergreen', code: 'evergreen' },
                { name: 'Heathered Red', code: 'heatheredred' },
              ].map((color) => (
                <button
                  key={color.name}
                  style={{ 
                    ...styles.colorButton, 
                    backgroundColor: this.colorMapping[color.code],
                    border: selectedColor.name === color.name ? '3px solid black' : 'none',
                  }}
                  onClick={() => this.handleColorSelect({ name: color.name, colorCode: this.colorMapping[color.code] })}
                >
                  {color.name}
                </button>
              ))}
            </div>
    
            {/* Product Details */}
            {selectedColor && productDetails && (
              <div style={styles.productDetails}>
                <h3>Selected Color: {selectedColor.name}</h3>
                <img src={`${AssetRoot}${correctedImagePath}`} alt="Product" style={styles.productImage} />
                <div>
                  <h4>{productDetails.brand} - {productDetails.style} ({productDetails.colorName})</h4>
                  <p>{productDetails.specs}</p>
                  <p>Available Sizes: {productDetails.sizes.join(', ')}</p>
                  <button
                    style={styles.selectProductButton}
                    onClick={() => this.handleProductSelect(productDetails)}
                  >
                    Select This Product
                  </button>
                </div>
              </div>
            )}
          </div>
          <PapaJohnsFooter/>
        </div>
      );
    }
}    


export const PapaJohnsColorSelect = withRouter(connect(mapStateToProps)(Radium(_PapaJohnsColorSelect)));
